/* eslint-disable */
/// This file is auto generated - do not edit manually
export const SeeOffer = 'Website.ProductOffer.SeeOffer';
export const TimeLeft = 'Website.ProductOffer.TimeLeft';
